module.exports = __webpack_public_path__ + "img/step1-b.17a24e6c.png";